import {BaseDescriptor} from "./baseDescriptor";

declare var Ext: any;
export default class EmptyDocHeaderFooterFix extends BaseDescriptor {
    introducedIn = '9.0.6';
    affectedStore = 'Company';
    name = 'EmptyDocHeaderFooterFix';
    dependencyStores = ['Document'];
    docTypesToCheck = [
        'Quote',
        'Invoice',
        'Worksheet',
        'Creditnote',
        'Expense',
        'Expense_creditnote',
    ];
    rules = [
        () => {
        const companyStore = Ext.getStore('Company');
            const companyRecord = companyStore.first();
            this.docTypesToCheck.forEach(docType => {
                if(companyRecord.get(`default${docType}Header`) === '<p><br></p>'){
                    companyRecord.set(`default${docType}Header`, '')
                }
                if(companyRecord.get(`default${docType}Footer`) === '<p><br></p>'){
                    companyRecord.set(`default${docType}Footer`, '')
                }
            })
            companyStore.sync();
            return {};
        },
        () => {
            const documentStore = Ext.getStore('Document');
            documentStore.getRecords().forEach(docRecord => {
                let needsPdfUpdate = false
                if(docRecord.get('header') === '<p><br></p>'){
                    docRecord.set('header','');
                    needsPdfUpdate = true;
                }
                if(docRecord.get('footer') === '<p><br></p>'){
                    docRecord.set('footer','');
                    needsPdfUpdate = true;
                }
                if(needsPdfUpdate){
                    docRecord.set('storage_url','');
                }
            })
            documentStore.sync();
            return {};
        }
    ];
}